import angular from 'angular';

class CommunityRegistrationCtrl {
  constructor($scope, $timeout, registration, $window, $location) {
    $scope.registration = registration;
    $scope.$location = $location;
    $scope.$watch(
      '$viewContentLoaded',
      () => {
        $timeout(() => {
          $('#side_banner').css({ height: $('#com-reg-form-area').height() });
        }, 100);
      },
    );

    angular.element($window).on('resize', () => {
      $('#side_banner').css({ height: $('#com-reg-form-area').height() });
    });
  }
}

CommunityRegistrationCtrl.$inject = ['$scope', '$timeout', 'registration', '$window', '$location'];

export default CommunityRegistrationCtrl;
